import BotPageCategoriesMultibrand from './json/bot/page-categories-multibrand.json';
import BotPageCategories from './json/bot/page-categories.json';
import BotPageDepartmentsMultibrand from './json/bot/page-departments-multibrand.json';
import BotPageDepartments from './json/bot/page-departments.json';
import EudPageCategories from './json/eud/page-categories.json';
import EudPageDepartments from './json/eud/page-departments.json';

export const categories: Record<string, any> = {
  bot: {
    'page-departments-multibrand': BotPageDepartmentsMultibrand,
    'page-departments': BotPageDepartments,
    'page-categories-multibrand': BotPageCategoriesMultibrand,
    'page-categories': BotPageCategories,
  },
  vdi: {
    'page-departments-multibrand': BotPageDepartmentsMultibrand,
    'page-departments': BotPageDepartments,
    'page-categories-multibrand': BotPageCategoriesMultibrand,
    'page-categories': BotPageCategories,
  },
  eud: {
    'page-departments': EudPageDepartments,
    'page-categories': EudPageCategories,
  },
};
